// import { createSlice } from "@reduxjs/toolkit";
// import { addSuperAdminRecharged } from "./ThunkAction"; // adjust path
// import { AdminRechargedValletState } from "./Types";

// const initialState: AdminRechargedValletState = {
//   detail: null,
//   loading: false,
//   message: null,
//   error: null,
// };

// const adminRechargedValletSlice = createSlice({
//   name: "adminRechargedVallet",
//   initialState,
//   reducers: {
//     clearAdminRechargedValletState: (state) => {
//       state.detail = null;
//       state.loading = false;
//       state.message = null;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(addSuperAdminRecharged.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.message = null;
//       })
//       .addCase(addSuperAdminRecharged.fulfilled, (state, action) => {
//         state.loading = false;
//         state.detail = action.payload.data || null;
//         state.message = action.payload.message;
//       })
//       .addCase(addSuperAdminRecharged.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload?.message || "Something went wrong";
//       });
//   },
// });

// export const { clearAdminRechargedValletState } = adminRechargedValletSlice.actions;

// export default adminRechargedValletSlice.reducer;





import { createSlice } from "@reduxjs/toolkit";
import { addSuperAdminRecharged, getSuperAdminRecharged } from "./ThunkAction"; 
import { AdminRechargedValletState } from "./Types";

const initialState: AdminRechargedValletState = {
  detail: null,
  list: null,  // ✅ typed properly
  loading: false,
  message: null,
  error: null,
};


const adminRechargedValletSlice = createSlice({
  name: "adminRechargedVallet",
  initialState,
  reducers: {
    clearAdminRechargedValletState: (state) => {
      state.detail = null;
      state.list = null;
      state.loading = false;
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // ✅ Add recharge
    builder
      .addCase(addSuperAdminRecharged.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(addSuperAdminRecharged.fulfilled, (state, action) => {
        state.loading = false;
        state.detail = action.payload?.data || null;
        state.message = action.payload?.message || null;
      })
      .addCase(addSuperAdminRecharged.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something went wrong";
      });

    // ✅ Get recharge list
    builder
      .addCase(getSuperAdminRecharged.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(getSuperAdminRecharged.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload?.data || null;
        state.message = action.payload?.message || null;
      })
      .addCase(getSuperAdminRecharged.rejected, (state, action) => {
        state.loading = false;
        // @ts-expect-error
        state.error = action.payload?.message || "Something went wrong";
      });
  },
});

export const { clearAdminRechargedValletState } = adminRechargedValletSlice.actions;

export default adminRechargedValletSlice.reducer;
